import type { ReactElement } from 'react'
import type { AppointmentDialogState } from '../useAppointmentDialog'
import { AppointmentDialogDefault } from './default'
import { AppointmentDialogCompact } from './compact'

export type AppointmentDialogVariant = (state: AppointmentDialogState) => ReactElement

/**
 * Map of available dialog-UI variants keyed by name.
 * Register additional variants here as they're added.
 * The value selected via VITE_APPOINTMENT_DIALOG_VARIANT must be a key in this map;
 * unknown names fall back to 'default'.
 */
export const APPOINTMENT_DIALOG_VARIANTS: Record<string, AppointmentDialogVariant> = {
	default: AppointmentDialogDefault,
	compact: AppointmentDialogCompact,
}

export function resolveAppointmentDialogVariant(name: string | undefined): AppointmentDialogVariant {
	if (name && APPOINTMENT_DIALOG_VARIANTS[name]) {
		return APPOINTMENT_DIALOG_VARIANTS[name]
	}
	return APPOINTMENT_DIALOG_VARIANTS.default
}
